import React from 'react'
import {VariantLabel} from 'components/Offer/Shared/VariantLabel'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {OfferVariant} from '@vio/core/src/offer/types/OfferVariant'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

interface MainProps {
  offer: SearchOffer
  anchorPrice: number
  anchorPriceTotal: number
  offerVariant: OfferVariant
  hotelHasMoreThanOneOffer: boolean
  hasTag: boolean
}

export const TagComponent: React.FC<MainProps> = ({
  offerVariant,
  offer,
  anchorPrice,
  anchorPriceTotal,
  hotelHasMoreThanOneOffer = false,
  hasTag = true
}) => {
  const {isMobile} = useDeviceLayout()

  if (!hasTag) {
    return null
  }

  const hasBestDealTag = !isMobile && hotelHasMoreThanOneOffer
  if (offerVariant === OfferVariant.BestDeal && !hasBestDealTag) {
    return null
  }

  if (offerVariant !== OfferVariant.Popular) {
    return (
      <VariantLabel
        hasPadding
        variant={offerVariant}
        offer={offer}
        anchorPrice={anchorPrice}
        anchorPriceTotal={anchorPriceTotal}
      />
    )
  }

  return null
}
